export default {
  'common.action': 'Action',
  'common.operator': 'Operator',
  'common.operationTime': 'Operation time',
  'common.add': 'Add',
  'common.edit': 'Edit',
  'common.copy': 'Copy',
  'common.amend': 'Amend',
  'common.delete': 'Delete',
  'common.sureToDelete': 'Are you sure you want to delete?',
  'common.confirm': 'Confirm',
  'common.cancel': 'Cancel',
  'common.back': 'Back',
  // Change password
  'common.changePassword': 'Change Password',
  'common.logout': 'Logout',
  'common.oldPassword': 'Old Password',
  'common.newPassword': 'New Password',
  'common.confirmPassword': 'Confirm Password',
  'common.pleaseEnterOldPassword': 'Please enter the old password',
  'common.pleaseEnterNewPassword': 'Please enter the new password',
  'common.pleaseEnterNewPasswordAgain': 'Please enter the new password again',
  'common.passwordMin6': 'Password must be at least 6 characters',
  'common.passwordLength6to50': 'Password must be 6-50 characters',
  'common.passwordFormat': 'Password only supports letters, numbers and special characters',
  'common.passwordNotMatch': 'The two passwords do not match',
  'common.changePasswordSuccess': 'Password changed successfully',
  'common.startTime.placeholder': 'Please select a start time',
  'common.endTime.placeholder': 'Please select a end time',
  'common.hint': 'Hint',
  'common.sort': 'Sort',
  'common.all': 'All',
  'common.type': 'Type',
  'common.language': 'Language',
  'common.operationFailed': 'Operation failed',
  'common.serialNumber': 'Serial number',
  'common.account': 'Account',
  'common.onlyUpload': 'Only upload {types} files',
  'common.remark': 'Remark',
  'common.pleaseEnter': 'Please enter',
  'common.operationSuccessful': 'Operation successful',
  'common.requestFail': 'Request Fail',
  'common.noResponse': 'No response! Please retry.',
  'common.requestError': 'Request error, please retry.',
  'common.save': 'Save',
  'common.uploadSuccessful': 'Upload successful',
  'common.uploadFailed': 'Upload failed',
  'common.requiredCannotEmpty': 'Required cannot be empty',
  'common.allowEnter200Characters': 'Allow enter 200 characters',
  'common.total': 'Total',
  'common.startTime': 'Start Time',
  'common.endTime': 'End Time',
  'common.dynamicPassword': 'Dynamic password',
  'common.dynamicMustBe6': 'Please enter a 6-digit dynamic password',
  'common.userDynamicPassword': "User's dynamic password",
  'common.enterUserDynamicPassword':
    "Please enter the dynamic password from the user's authenticator",
  'common.operatorDynamicPassword': 'Your dynamic password',
  'common.enterOperatorDynamicPassword': 'Please enter your own dynamic password',
  'common.view': 'View',
  'common.close': 'Close',
  'common.loading': 'Loading...',
  'common.submit': 'Submit',
  'common.upload': 'Upload',
  'common.select.all': 'Select All',
  'common.detail': 'Detail',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.reject': 'Reject',
  'common.enable': 'Enable',
  'common.disable': 'Disable',
  'common.qRCode': 'QR code',
  'common.pass': 'Pass',
  'common.exportData': 'Are you sure you want to export the data?',
  'common.enterDynamicPassword': 'Please enter the dynamic password',
  'common.applyTime': 'Application time',
  'common.query': 'Query',
  'common.verify': 'Verify',
  'common.operator/OperationTime': 'Operator/Operation time',
  'common.confirm1': 'Confirm',
  'common.people': 'People',
  'common.count': 'Txns',
  'common.noAccessPermission': 'No permission to access this page',
  'common.noPermission': 'No query permission, please contact the administrator',
  'common.export': 'Export',
  'common.maxExceedmin': 'The maximum value cannot be less than the minimum value',
  'common.minExceedMax': 'The minimum value cannot be greater than the maximum value',
  'editor.bold': 'Bold',
  'editor.italic': 'Italic',
  'editor.underline': 'Underline',
  'editor.strike': 'Strike',
  'editor.blockquote': 'Blockquote',
  'editor.codeBlock': 'Code Block',
  'editor.link': 'Link',
  'editor.image': 'Image',
  'editor.video': 'Video',
  'editor.orderedList': 'Ordered List',
  'editor.bulletList': 'Bullet List',
  'editor.decreaseIndent': 'Decrease Indent',
  'editor.increaseIndent': 'Increase Indent',
  'editor.superscript': 'Superscript',
  'editor.subscript': 'Subscript',
  'editor.direction': 'Text Direction',
  'editor.table': 'Insert Table',
  'editor.font': 'Font',
  'editor.header': 'Header',
  'editor.fontSize': 'Font Size',
  'editor.textColor': 'Text Color',
  'editor.backgroundColor': 'Background Color',
  'editor.align': 'Align',
  'common.minute': 'Minute',
  'common.suggestSize': 'Suggest Size',
  'common.validateRange': 'Please enter 1-99 integer',
  'common.phone': 'Phone Number',
  'common.status': 'Status',
};
